export default __webpack_public_path__ + "static/media/square-battery.dd5bc80e.svg";